import React from 'react';
import { useState, useEffect, useRef } from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  Form,
  Input,
  Button,
  Row,
  Col,
  Steps,
  Upload,
  message,
  Select,
  Space,
  Tabs,
  Modal,
  Tooltip,
  Table,
} from 'antd';
import step_base_icon from '../../../../assets/icons/step_base_icon.png';
import quaterly_input from '../../../../assets/icons/quarterly_input.png';
import {
  getProjectList,
  getFetchQuarterly,
  createCalculateQuarterly,
  createSubmitQuarterly,
  getQuarterlyView,
  getProjectListManager,
  fetchEstimate,
  getFinancialYear,
  getQuarter,
  getViewProject,
  getQuarterManager,
} from '../../redux/slice';
import { useSelector, useDispatch } from 'react-redux';
import LocalStorage from '../../../../utilities/localStorage.js';
import dashboardCircle from '../../../../assets/icons/dashboard-circle.png';
import { set } from 'lodash';

const { Step } = Steps;
const { TabPane } = Tabs;

const QuarterlyInputPage = () => {
  const user_details = LocalStorage.getItem('bbs_user');
  console.log('user_details:', user_details);

  const [quarters, setQuarters] = useState([]);
  const [estimatedValues, setEstimatedValues] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const [savings, setSavings] = useState(false);
  const [savingsValue, setSavingsValue] = useState(false);
  const [savingsInTons, setSavingsInTons] = useState(0);
  const [estimatedValueApi, setEstimatedValueApi] = useState(null);
  const [estimatedValueTonnageBBS, setEstimatedValueTonnageBBS] =
    useState(null);
  const [calculation, setCalculation] = useState(false);
  const [quarterlyViewData, setQuarterlyViewData] = useState([]);
  const [estimatedWasteVal, setEstimatedWasteVal] = useState(false);
  const [datasource, setDatasource] = useState([]);
  const [quantityWithTool, setQuantityWithTool] = useState(null);
  const [quantityWithoutTool, setQuantityWithoutTool] = useState(null);
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);

  const [formValues, setFormValues] = useState({
    financial_year: '',
    quarter: '',
    project_code: '',
  });
  const [overallWastePer, setOverallWastePer] = useState(null);

  const handleInputChange = (field, value) => {
    setFormValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFetchEstimate = (quarter, projectCode) => {
    const params = {
      quarter: quarter,
      project_code: projectCode,
    };
    dispatch(fetchEstimate(params))
      .then((res) => {
        if (res.payload?.success) {
          if (
            !res?.payload?.estimate_value &&
            res?.payload?.quantity_with_tool === 0 &&
            user_details?.user?.Role?.role === 'REQUESTER'
          ) {
            setIsModalVisible(true);
            form.setFieldsValue({
              budgeted_wastage: '',
              savings_per: '',
              savings_in_ton: '',
              savings_in_lakh: '',
            });
            return;
          }
          //message.success(res.payload.message)
          form.setFieldsValue({
            estimate_waste_per_system: res?.payload?.estimate_value || 0,
            estimate_tonnage_with_bbs: res?.payload?.quantity_with_tool || 0,
          });
          setEstimatedValueApi(res?.payload?.estimate_value);
          setEstimatedValueTonnageBBS(res?.payload?.quantity_with_tool);
          setEstimatedWasteVal(true);

          const estimateTonnageWithBBS = res?.payload?.quantity_with_tool || 0;
          const savingsPercent = Number(savingsValue).toFixed(2);

          const savingsInTons = Number(
            estimateTonnageWithBBS * savingsPercent,
          ).toFixed(2);
          form.setFieldsValue({
            savings_in_ton: savingsInTons,
            savings_in_lakh: Number(
              Number(savingsInTons * 55000) / 100000,
            ).toFixed(1),
          });
          setSavings(true);
        } else {
          console.error('Backend response does not indicate success.');
        }
      })
      .catch((error) => {
        console.error('Error fetching final Bbs summary files:', error);
      });
  };

  const handleEstimateClick = () => {
    console.log('Button clicked');
    // Get the value of "Estimate The Tonnage With BBS"
    const tonnageWithBBS = form.getFieldValue('estimate_tonnage_with_bbs');

    if (tonnageWithBBS) {
      // Calculate the value and update "Estimate Waste Percentage - System (%)"
      const estimatedWaste = (Number(tonnageWithBBS) / 10).toFixed(2); // Divide by 10 and format to 2 decimal places
      console.log('Estimated waste:', estimatedWaste);
      setEstimatedValues(estimatedWaste);
      form.setFieldsValue({
        estimate_waste_per_system: estimatedWaste,
      });
      setEstimatedWasteVal(true);
    } else {
      // Handle case where no value is entered in "Estimate The Tonnage With BBS"
      console.warn('Please enter a value in "Estimate The Tonnage With BBS"');
    }
  };

  const handleCalculateOverallWasterPer = (
    estimate_tonnage_with_bbs,
    estimate_waste_per_actual,
    estimate_tonnage_without_bbs,
    estimate_waste_per_actual_wo,
  ) => {
    // Get the form values
    // const tonnageWithBBS = form.getFieldValue('estimate_tonnage_with_bbs');
    // const wastePercentageSystem = estimatedValueApi;
    // const tonnageWithoutBBS = form.getFieldValue(
    //   'estimate_tonnage_without_bbs',
    // );
    // const wastePercentageActual = form.getFieldValue(
    //   'estimate_waste_per_actual_wo',
    // );
    const payload = {
      estimate_tonnage_with_bbs,
      estimate_waste_per_actual,
      estimate_tonnage_without_bbs,
      estimate_waste_per_actual_wo: estimate_waste_per_actual_wo,
    };
    dispatch(createCalculateQuarterly(payload))
      .then((response) => {
        const { overall_waste_per } = response.payload;
        setOverallWastePer(overall_waste_per);
        form.setFieldsValue({
          overall_waste_per: Number(overall_waste_per).toFixed(2) || 0,
        });
      })
      .catch((error) => {
        console.error('API call failed:', error.message);
      });
  };

  const items = [
    {
      key: '1',
      label: 'Without BBS',
      //children: 'Content of Tab Pane 1',
    },
    {
      key: '2',
      label: 'With BBS',
      //children: 'Content of Tab Pane 2',
    },
  ];

  const [activeTab, setActiveTab] = useState('1');
  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const [wastedisabled, setWasteDisabled] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [alertShown, setAlertShown] = useState(false);
  const [selectedProjectCode, setSelectedProjectCode] = useState('');

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Option } = Select;

  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});

  const [activeButton, setActiveButton] = useState('new'); // Default active button

  const handleButtonClick = (buttonType) => {
    setActiveButton(buttonType); // Update the active button
  };

  const [currentStep, setCurrentStep] = useState(0);
  const [search, setSearch] = useState();

  const {
    projectListData,
    quarterlyData,
    projectListManagerData,
    loading,
    financialYear,
    quarter,
    getViewProjectLoading,
    getViewProjectData,
  } = useSelector((state) => state.quarterlyInput);
  useEffect(() => {
    if (user_details?.user?.id) {
      dispatch(getProjectList({ userId: user_details.user.id }));
    }
  }, [dispatch]);

  useEffect(() => {
    if (user_details?.user?.id) {
      dispatch(getProjectListManager({ manager_id: user_details.user.id }));
    }
  }, [dispatch]);

  useEffect(() => {
    if (user_details?.user?.id) {
      dispatch(getFinancialYear());
    }
  }, [dispatch]);

  const handleFinancialYearChange = (selectedYear) => {
    form.setFieldsValue({ quarter: null }); // Reset quarter when year changes
    setFormValues((prev) => ({ ...prev, financial_year: selectedYear }));

    if (user_details?.user?.Role?.role === 'REQUESTER') {
      dispatch(
        getQuarter({
          user_id: user_details?.user?.id,
          financialYear: selectedYear,
          project_code: form.getFieldValue('project_code'),
        }),
      )
        .unwrap()
        .then((response) => {
          if (response?.success) {
            console.log('Quarter data fetched successfully');
          } else {
            message.error(response?.message || 'Failed to fetch quarters');
          }
        })
        .catch((error) => {
          message.error(
            error?.message || 'An error occurred while fetching quarters',
          );
        });
    } else {
      dispatch(
        getQuarterManager({
          financialYear: selectedYear,
        }),
      )
        .unwrap()
        .then((response) => {
          if (response?.success) {
            console.log('Quarter data fetched successfully');
          } else {
            message.error(response?.message || 'Failed to fetch quarters');
          }
        })
        .catch((error) => {
          message.error(
            error?.message || 'An error occurred while fetching quarters',
          );
        });
    }
  };

  console.log('manager project list@: ', projectListManagerData);

  // useEffect(() => {
  //   if (formValues.project_code) {
  //     let payload = {
  //       project_code: formValues.project_code,
  //       financial_year: formValues.financial_year,
  //       quarter: formValues.quarter
  //     }
  //     dispatch(getQuarterlyView(payload));
  //     setIsDisabled(true);
  //   } else {
  //     setIsDisabled(false);
  //   }

  // }, [dispatch, formValues.project_code,]);

  useEffect(() => {
    const checkFields = () => {
      const values = form.getFieldsValue([
        'estimate_tonnage_with_bbs',
        'estimate_tonnage_without_bbs',
        'total_tonnage',
        'estimate_waste_per_actual',
        'estimate_waste_per_actual_wo',
        'overall_waste_per',
        'budgeted_wastage',
        'savings_per',
        'savings_in_ton',
        'savings_in_lakh',
      ]);
      const allFilled = Object.values(values).every((value) => value);
      setIsBtnDisabled(!allFilled);
    };

    checkFields();
  }, [form]);

  console.log('quarterlyViewData:', quarterlyViewData);

  const handleEstimateActualChange = () => {
    const values = form.getFieldsValue();
    const { budgeted_wastage, estimate_waste_per_actual } = values;

    if (budgeted_wastage && estimate_waste_per_actual) {
      // Calculate wastage monitoring
      const wastageMonitoring = (
        Number(budgeted_wastage) - Number(estimate_waste_per_actual)
      ).toFixed(2);

      // Update the wastage_monitoring field
      form.setFieldsValue({
        wastage_monitoring: wastageMonitoring,
      });
      setWasteDisabled(true);
    }
  };

  useEffect(() => {
    console.log('Dependencies changed', formValues, user_details?.user?.id);
    if (
      formValues.financial_year &&
      formValues.quarter &&
      formValues.project_code &&
      user_details?.user?.id
    ) {
      dispatch(
        getFetchQuarterly({
          userId: user_details.user.id,
          financial_year: formValues.financial_year,
          quarter: formValues.quarter,
          project_code: formValues.project_code,
        }),
      )
        .unwrap()
        .then((response) => {
          if (response) {
            // Update the form instance with the API response
            form.setFieldsValue({
              project_name: response.project_name,
              total_tonnage_for_quarter: response.total_tonnage_for_quarter,
              budgeted_wastage: response.budgeted_wastage,
              // estimate_tonnage_with_bbs: null,
              // estimate_waste_per_system: null,
              // estimate_waste_per_actual: null,
              // estimate_tonnage_without_bbs: null,
              // estimate_waste_per_actual_wo: null,
              // wastage_monitoring: null,
              // overall_waste_percentage: null,
              //   savings_per: null,
              // savings_in_ton: null,
              // savings_in_lakh: null,
            });
            setFieldsDisabled(true);
            const values = form.getFieldsValue();
            const budgetedWastage = response.budgeted_wastage;
            const estimateWastePerSystem =
              values.estimate_waste_per_system || 0;

            if (budgetedWastage) {
              const savingsValue = budgetedWastage - estimateWastePerSystem;
              form.setFieldsValue({
                savings_per: Number(savingsValue).toFixed(2),
              });
              setSavingsValue(Number(savingsValue).toFixed(2));
              setSavings(true);
            }

            const estimateTonnageWithBBS = values.estimate_tonnage_with_bbs;
            const savingsPercent = Number(savingsValue).toFixed(2);

            if (estimateTonnageWithBBS && savingsPercent) {
              const savingsInTons = Number(
                estimateTonnageWithBBS * savingsPercent,
              ).toFixed(2);
              form.setFieldsValue({
                savings_in_ton: savingsInTons,
                savings_in_lakh: Number(
                  Number(savingsInTons * 55000) / 100000,
                ).toFixed(1),
              });
              setSavings(true);
            }
          }
        })
        .catch((error) => {
          console.error('Error fetching quarterly data:', error);
        });
    }
  }, [formValues.quarter, user_details?.user?.id, dispatch, form]);

  // useEffect(() => {
  //   console.log('Projects:', projectListData);
  // }, [projectListData]);

  // useEffect(() => {
  //   console.log('fetch quarterly Details: ', quarterlyData);
  // }, [quarterlyData]);

  // const handleFinancialYearChange = (value) => {
  //   const yearRange = value.split(" ")[0];
  //   const [startYear, endYear] = yearRange.split("-");
  //   const dynamicQuarters = [
  //     `${startYear}-${endYear} Q1(1-Apr-${startYear} to 30-Jun-${startYear})`,
  //     `${startYear}-${endYear} Q2(1-Jul-${startYear} to 30-Sep-${startYear})`,
  //     `${startYear}-${endYear} Q3(1-Oct-${startYear} to 31-Dec-${startYear})`,
  //     `${startYear}-${endYear} Q4(1-Jan-FY${endYear} to 31-Mar-FY${endYear})`,
  //   ];
  //   setQuarters(dynamicQuarters);
  //   setFormValues((prev) => ({ ...prev, financial_year: value }));
  // };

  const handleQuarterChange = (value) => {
    setFormValues((prev) => ({ ...prev, quarter: value }));
  };

  const handleProjectCodeChange = (value) => {
    setSelectedProjectCode(value);
    setFormValues((prev) => ({ ...prev, project_code: value }));
    dispatch(getViewProject({ projectCode: value })).then((res) => {
      form.setFieldsValue({ project_name: res?.payload?.project_name });
    });
  };

  // useEffect(() => {
  //   // if (selectedProjectCode ) {
  //   //   // If it's a new project code, reset alertShown and show the modal if needed
  //   //   setAlertShown(false);
  //   // }else{
  //   //   if (user_details?.user?.Role?.role=== 'MANAGER' &&
  //   //     selectedProjectCode && !alertShown && (!quarterlyViewData?.data || quarterlyViewData?.data?.length === 0))
  //   //      {
  //   //     setIsModalVisible(true);
  //   //     setAlertShown(true);

  //   //   // }

  //   // }

  // }, [selectedProjectCode, quarterlyViewData, alertShown,user_details]);

  const handleChange = (changedValue, values) => {
    // if (changedValue.financial_year || changedValue.quarter) {
    //   form.setFieldsValue({ project_code: null })
    // }
    if (
      changedValue.estimate_tonnage_without_bbs &&
      values.estimate_waste_per_actual &&
      values.estimate_waste_per_actual_wo
    ) {
      setIsBtnDisabled(false);
    } else if (
      values.estimate_tonnage_without_bbs &&
      changedValue.estimate_waste_per_actual &&
      values.estimate_waste_per_actual_wo
    ) {
      setIsBtnDisabled(false);
    } else if (
      values.estimate_tonnage_without_bbs &&
      values.estimate_waste_per_actual &&
      changedValue.estimate_waste_per_actual_wo
    ) {
      setIsBtnDisabled(false);
    } else {
      setIsBtnDisabled(true);
    }

    // changedValue.estimate_tonnage_with_bbs ||
    // changedValue.estimate_tonnage_without_bbs ||
    // changedValue.total_tonnage ||
    // changedValue.estimate_waste_per_actual ||
    // changedValue.estimate_waste_per_actual_wo ||
    // changedValue.overall_waste_per ||
    // changedValue.budgeted_wastage ||
    // changedValue.savings_per ||
    // changedValue.savings_in_ton ||
    // changedValue.savings_in_lakh

    if (changedValue.project_code) {
      // Reset financial_year and quarter first
      form.setFieldsValue({
        financial_year: null,
        quarter: null,
      });
    }

    if (changedValue.quarter || changedValue.financial_year) {
      form.setFieldsValue({
        estimate_tonnage_without_bbs: '',
        total_tonnage: '',
        estimate_waste_per_actual: '',
        estimate_waste_per_actual_wo: '',
        overall_waste_per: '',
      });
    }

    if (
      changedValue.project_code ||
      changedValue.financial_year ||
      changedValue.quarter
    ) {
      if (values.quarter && values.project_code) {
        handleFetchEstimate(values.quarter, values.project_code);
      }
      if (!values.project_code || !values.financial_year || !values.quarter)
        return;
      let payload = {
        project_code: values.project_code,
        financial_year: values.financial_year,
        quarter: values.quarter,
      };
      dispatch(getQuarterlyView(payload)).then((response) => {
        if (
          response?.payload?.success &&
          user_details?.user?.Role?.role === 'MANAGER'
        ) {
          setQuarterlyViewData(response?.payload);
          const data = response?.payload?.data;
          setDatasource([
            {
              key: '1',
              row_label: 'Quantity',
              row_label_units: 'MT',
              with_tool: data?.estimate_tonnage_with_bbs,
              without_tool: data?.estimate_tonnage_without_bbs,
              total: Number(
                data?.estimate_tonnage_with_bbs +
                  data?.estimate_tonnage_without_bbs,
              ).toFixed(2),
              with_tool_disabled: true,
              without_tool_disabled: true,
              total_disabled: true,
            },
            {
              key: '2',
              row_label: 'Recommended wastage from the tool',
              row_label_units: '%',
              with_tool: data?.estimate_waste_per_system,
              without_tool: '',
              total: '',
              with_tool_disabled: true,
              without_tool_disabled: true,
              total_disabled: true,
            },
            {
              key: '3',
              row_label: 'Actual wastage during execution',
              row_label_units: '%',
              with_tool: data?.estimate_waste_per_actual,
              without_tool: data?.estimate_waste_per_actual_wo,
              total: Number(data?.overall_waste_percentage).toFixed(2),
              with_tool_disabled: true,
              without_tool_disabled: true,
              total_disabled: true,
            },
            {
              key: '4',
            },
            {
              key: '5',
              row_label: 'Budgeted wastage',
              row_label_units: '%',
              with_tool: '',
              without_tool: '',
              total: data?.budgeted_wastage,
              total_disabled: true,
            },
            {
              key: '6',
              row_label: 'Savings / Overruns wastage',
              row_label_units: '%',
              with_tool: '',
              without_tool: '',
              total: data?.savings_per,
              total_disabled: true,
            },
            {
              key: '7',
              row_label: 'Savings /  Overruns',
              row_label_units: 'MT',
              with_tool: '',
              without_tool: '',
              total: data?.savings_in_ton,
              total_disabled: true,
            },
            {
              key: '8',
              row_label: 'Savings /  Overruns',
              row_label_units: 'Rs Lakhs',
              with_tool: '',
              without_tool: '',
              total: Number(data?.savings_in_lakh).toFixed(1),
              total_disabled: true,
              tooltip: '@ steel rates of INR 55,000 per MT',
            },
          ]);
          if (
            user_details?.user?.Role?.role === 'MANAGER' &&
            values.project_code &&
            !alertShown &&
            (!response?.payload?.data || response?.payload?.data?.length === 0)
          ) {
            setIsModalVisible(true);
            //setAlertShown(true);
            setIsDisabled(true);

            // }
          } else {
            setIsDisabled(true);
            setIsModalVisible(false);
          }
        }
      });
      //setIsDisabled(true);
      if (user_details?.user?.Role?.role === 'REQUESTER') {
        setDatasource([
          {
            key: '1',
            row_label: 'Quantity',
            row_label_units: 'MT',
            with_tool: 'estimate_tonnage_with_bbs',
            without_tool: 'estimate_tonnage_without_bbs',
            total: 'total_tonnage',
            total_disabled: true,
            with_tool_disabled: true,
          },
          {
            key: '2',
            row_label: 'Recommended wastage from the tool',
            row_label_units: '%',
            with_tool: 'estimate_waste_per_system',
            without_tool: '',
            total: '',
            disabled: true,
          },
          {
            key: '3',
            row_label: 'Actual wastage during execution',
            row_label_units: '%',
            with_tool: 'estimate_waste_per_actual',
            without_tool: 'estimate_waste_per_actual_wo',
            total: 'overall_waste_per',
            total_disabled: true,
          },
          {
            key: '4',
          },
          {
            key: '5',
            row_label: 'Budgeted wastage',
            row_label_units: '%',
            with_tool: '',
            without_tool: '',
            total: 'budgeted_wastage',
            total_disabled: true,
          },
          {
            key: '6',
            row_label: 'Savings / Overruns wastage',
            row_label_units: '%',
            with_tool: '',
            without_tool: '',
            total: 'savings_per',
            total_disabled: true,
          },
          {
            key: '7',
            row_label: 'Savings /  Overruns',
            row_label_units: 'MT',
            with_tool: '',
            without_tool: '',
            total: 'savings_in_ton',
            total_disabled: true,
          },
          {
            key: '8',
            row_label: 'Savings /  Overruns',
            row_label_units: 'Rs Lakhs',
            with_tool: '',
            without_tool: '',
            total: 'savings_in_lakh',
            total_disabled: true,
            tooltip: '@ steel rates of INR 55,000 per MT',
          },
        ]);

        const budgetedWastage = values.budgeted_wastage;
        const estimateWastePerSystem = values.estimate_waste_per_system || 0;

        if (budgetedWastage) {
          const savingsValue = budgetedWastage - estimateWastePerSystem;
          form.setFieldsValue({
            savings_per: Number(savingsValue).toFixed(2),
          });
          setSavings(true);
        }
      }
    }

    if (changedValue.estimate_tonnage_without_bbs) {
      const totalTonnage =
        Number(values.estimate_tonnage_with_bbs) +
        Number(values.estimate_tonnage_without_bbs);
      form.setFieldsValue({ total_tonnage: Number(totalTonnage).toFixed(2) });
    }

    if (user_details?.user?.Role?.role === 'REQUESTER') {
      // const estimateTonnageWithBBS = values.estimate_tonnage_with_bbs;
      // const savingsPercent = values.savings_per;

      // if (estimateTonnageWithBBS && savingsPercent) {
      //   const savingsInTons = (estimateTonnageWithBBS * savingsPercent).toFixed(
      //     2,
      //   );
      //   form.setFieldsValue({ savings_in_ton: savingsInTons });
      //   setSavings(true);
      // }

      // const savingsInTons = values.savings_in_ton;
      // if (savingsInTons) {
      //   const savingsInLakhs = (savingsInTons * 55000).toFixed(2);
      //   form.setFieldsValue({ savings_in_lakh: savingsInLakhs });
      //   setCalculation(true);
      // }

      // overall wastage calcualtions

      const quantityWithTool = values.estimate_tonnage_with_bbs || 0;
      const actualWastageWithTool = Number(values.estimate_waste_per_actual);
      const quantityWithoutTool = Number(values.estimate_tonnage_without_bbs);
      console.log(quantityWithoutTool);
      const actualWastageWithoutTool = Number(
        values.estimate_waste_per_actual_wo,
      );
      if (
        changedValue.estimate_tonnage_with_bbs &&
        quantityWithoutTool &&
        actualWastageWithoutTool &&
        actualWastageWithTool
      ) {
        handleCalculateOverallWasterPer(
          quantityWithTool,
          actualWastageWithTool,
          quantityWithoutTool,
          actualWastageWithoutTool,
        );
      }
      if (
        changedValue.estimate_waste_per_actual &&
        quantityWithoutTool &&
        actualWastageWithoutTool
      ) {
        handleCalculateOverallWasterPer(
          quantityWithTool,
          actualWastageWithTool,
          quantityWithoutTool,
          actualWastageWithoutTool,
        );
      }
      if (
        changedValue.estimate_tonnage_without_bbs &&
        actualWastageWithoutTool &&
        actualWastageWithTool
      ) {
        handleCalculateOverallWasterPer(
          quantityWithTool,
          actualWastageWithTool,
          quantityWithoutTool,
          actualWastageWithoutTool,
        );
      }
      if (
        quantityWithoutTool &&
        actualWastageWithTool &&
        changedValue.estimate_waste_per_actual_wo
      ) {
        handleCalculateOverallWasterPer(
          quantityWithTool,
          actualWastageWithTool,
          quantityWithoutTool,
          actualWastageWithoutTool,
        );
      }
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const onSubmit = () => {
    // Get the form values (make sure you have these values from your form)
    const financialYear = form.getFieldValue('financial_year');
    const quarter = form.getFieldValue('quarter');
    const projectCode = form.getFieldValue('project_code');
    const projectName = form.getFieldValue('project_name');
    const totalTonnageForQuarter = form.getFieldValue(
      'total_tonnage_for_quarter',
    );
    const budgetedWastage = form.getFieldValue('budgeted_wastage');
    const estimateTonnageWithBBS = Number(
      form.getFieldValue('estimate_tonnage_with_bbs'),
    );
    const estimateWastePerActual = Number(
      form.getFieldValue('estimate_waste_per_actual'),
    );
    const estimateTonnageWithoutBBS = Number(
      form.getFieldValue('estimate_tonnage_without_bbs'),
    );
    const estimateWastePerActualWithout = Number(
      form.getFieldValue('estimate_waste_per_actual_wo'),
    );
    if (
      !estimateWastePerActual ||
      !estimateTonnageWithoutBBS ||
      !estimateWastePerActualWithout
    ) {
      message.error('Please enter the details to submit quarterly input.');
      return;
    }
    const wastageMonitoring = Number(form.getFieldValue('wastage_monitoring'));
    const savingsPer = Number(form.getFieldValue('savings_per'));
    const savingsInTon = Number(form.getFieldValue('savings_in_ton'));
    const savingsInLakh = Number(form.getFieldValue('savings_in_lakh'));
    //const overallWastePercentage = form.getFieldValue('overall_waste_percentage');
    //const userId = form.getFieldValue('user_id');

    // Create the payload for the API request
    const payload = {
      financial_year: financialYear,
      quarter: quarter,
      project_code: projectCode,
      project_name: projectName,
      total_tonnage_for_quarter: totalTonnageForQuarter,
      budgeted_wastage: budgetedWastage,
      estimate_tonnage_with_bbs: estimateTonnageWithBBS,
      estimate_waste_per_system: estimatedValueApi,
      estimate_waste_per_actual: estimateWastePerActual,
      estimate_tonnage_without_bbs: estimateTonnageWithoutBBS,
      estimate_waste_per_actual_wo: estimateWastePerActualWithout,
      wastage_monitoring: wastageMonitoring,
      overall_waste_percentage: overallWastePer,
      user_id: user_details?.user?.id,
      savings_per: savingsPer,
      savings_in_ton: savingsInTon,
      savings_in_lakh: savingsInLakh,
    };
    dispatch(createSubmitQuarterly(payload))
      .then((response) => {
        if (response?.payload?.success) {
          console.log('Submit successful:', response.payload);
          message.success(
            'Details for selected quarter has been updated successfully!',
          );
          navigate('/dashboard');
        } else {
          message.error('Submission failed. Please try again.');
        }
      })
      .catch((error) => {
        console.error('API call failed:', error.message);
        message.error('An error occurred while submitting. Please try again.');
      });
  };

  // useEffect(() => {
  //   console.log('Updated quarterlyViewData:', quarterlyViewData);
  // }, [quarterlyViewData]);

  useEffect(() => {
    setDatasource([
      {
        key: '1',
        row_label: 'Quantity',
        row_label_units: 'MT',
        with_tool: '',
        without_tool: '',
        total: '',
      },
      {
        key: '2',
        row_label: 'Recommended wastage from the tool',
        row_label_units: '%',
        with_tool: '',
        without_tool: '',
        total: '',
      },
      {
        key: '3',
        row_label: 'Actual wastage during execution',
        row_label_units: '%',
        with_tool: '',
        without_tool: '',
        total: '',
      },
      {
        key: '4',
      },
      {
        key: '5',
        row_label: 'Budgeted wastage',
        row_label_units: '%',
        with_tool: '',
        without_tool: '',
        total: '',
      },
      {
        key: '6',
        row_label: 'Savings / Overruns wastage',
        row_label_units: '%',
        with_tool: '',
        without_tool: '',
        total: '',
      },
      {
        key: '7',
        row_label: 'Savings /  Overruns',
        row_label_units: 'MT',
        with_tool: '',
        without_tool: '',
        total: '',
      },
      {
        key: '8',
        row_label: 'Savings /  Overruns',
        row_label_units: 'Rs Lakhs',
        with_tool: '',
        without_tool: '',
        total: '',
        tooltip: '@ steel rates of INR 55,000 per MT',
      },
    ]);
  }, []);

  // useEffect(()=>{
  //   return(()=>{
  //     form.resetFields()
  //   })
  // },[])

  // useEffect(() => {
  //   const budgetedWastage = form.getFieldValue('budgeted_wastage');
  //   const estimateWastePerSystem = estimatedValueApi;

  //   if (budgetedWastage !== undefined && estimateWastePerSystem !== undefined) {
  //     const savingsValue = budgetedWastage - estimateWastePerSystem;
  //     // Set the calculated savings value
  //     form.setFieldsValue({ savings_per: savingsValue });
  //     setSavings(true)
  //   }

  // }, [form.getFieldValue('budgeted_wastage'), estimatedValueApi]);

  // useEffect(() => {
  //   const estimateTonnageWithBBS = form.getFieldValue('estimate_tonnage_with_bbs');
  //   const savingsPercent = form.getFieldValue('savings_per');

  //   if (estimateTonnageWithBBS && savingsPercent) {
  //     const savingsInTons = (estimateTonnageWithBBS * (savingsPercent)).toFixed(2);

  //     form.setFieldsValue({
  //       savings_in_ton: savingsInTons,
  //     });
  //     setSavings(true)
  //   }

  // }, [form.getFieldValue('estimate_tonnage_with_bbs'), form.getFieldValue('savings_per')]);

  // useEffect(() => {
  //   setSavingsInTons(form.getFieldValue('savings_in_ton'));
  // }, [form]); // Updates state when form changes

  // useEffect(() => {
  //   if (savingsInTons) {
  //     const savingsInLakhs = (savingsInTons * 55000).toFixed(2);
  //     form.setFieldsValue({ savings_in_lakh: savingsInLakhs });
  //     setCalculation(true);
  //   }
  // }, [savingsInTons,form.getFieldValue('savings_in_ton')]);

  useEffect(() => {
    const estimateTonnageWithBBS = estimatedValueTonnageBBS || 0;
    const savingsPercent = Number(savingsValue).toFixed(2);

    const savingsInTons = (estimateTonnageWithBBS * savingsPercent).toFixed(2);
    form.setFieldsValue({
      savings_in_ton: savingsInTons,
      savings_in_lakh: Number(Number(savingsInTons * 55000) / 100000).toFixed(
        1,
      ),
    });
  }, [savingsValue, estimatedValueTonnageBBS, form]);

  const columns = [
    {
      title: null,
      dataIndex: 'row_label',
      key: 'row_label',
      width: '15%',

      render: (text, record) =>
        record.key === '4' ? (
          <p className="py-4"></p>
        ) : record.tooltip ? (
          <div className="flex items-center">
            <p className="text-xs px-4 py-2 text-[#101828] font-['SF-Pro-Text-Regular, sans-serif']">
              {text}
            </p>
            <Tooltip
              title={record.tooltip}
              overlayInnerStyle={{ fontSize: '10px' }}
            >
              <img
                className="w-3.5 h-3.5 cursor-pointer"
                src={dashboardCircle}
                alt="Info Icon"
              />
            </Tooltip>
          </div>
        ) : (
          <p className="text-xs px-4 py-2 text-[#101828] font-['SF-Pro-Text-Regular, sans-serif']">
            {text}
          </p>
        ),
    },
    {
      title: (
        <span className="font-semibold text-sm font-['SF-Pro-Text-Regular, sans-serif'] text-white">
          Units
        </span>
      ),
      dataIndex: 'row_label_units',
      key: 'row_label_units',
      width: '10%',
      render: (text, record) =>
        record.key === '4' ? (
          <p className="py-4"></p>
        ) : (
          <p className="text-xs py-2 px-4 text-[#101828] font-['SF-Pro-Text-Regular, sans-serif'] font-medium">
            {text}
          </p>
        ),
    },
    {
      title: (
        <span className="font-semibold text-sm font-['SF-Pro-Text-Regular, sans-serif'] text-white">
          With tool
        </span>
      ),
      dataIndex: 'with_tool',
      key: 'with_tool',
      width: '10%',
      render: (text, record) =>
        record.key === '4' ? (
          <p className="py-4"></p>
        ) : user_details?.user?.Role?.role === 'REQUESTER' ? (
          record.with_tool ? (
            <Form.Item name={record.with_tool} className="!m-0 !p-0" noStyle>
              <Input
                onChange={
                  record.with_tool === 'estimate_waste_per_actual'
                    ? handleEstimateActualChange()
                    : () => null
                }
                className="focus-within:!border-none !rounded-none focus-within:!outline-none focus:!border-none focus:!outline-none !outline-none !border-none !m-0"
                disabled={record.with_tool_disabled || record.disabled}
              />
            </Form.Item>
          ) : (
            <p className="py-4 bg-[#0000000a]"></p>
          )
        ) : (
          <Input
            // onChange={}
            className="focus-within:!border-none !rounded-none focus-within:!outline-none focus:!border-none focus:!outline-none !outline-none !border-none !m-0 bg-[#0000000a]"
            value={text || ''}
            disabled={record.with_tool_disabled}
          />
        ),
    },
    {
      title: (
        <span className="font-semibold text-sm font-['SF-Pro-Text-Regular, sans-serif'] text-white">
          Without tool
        </span>
      ),
      dataIndex: 'without_tool',
      key: 'without_tool',
      width: '10%',
      render: (text, record) =>
        record.key === '4' ? (
          <p className="py-4"></p>
        ) : user_details?.user?.Role?.role === 'REQUESTER' ? (
          record.without_tool ? (
            <Form.Item name={record.without_tool} className="!m-0 !p-0" noStyle>
              <Input
                className="focus-within:!border-none !rounded-none focus-within:!outline-none focus:!border-none focus:!outline-none !outline-none !border-none !m-0"
                disabled={record.without_tool_disabled}
              />
            </Form.Item>
          ) : (
            <p className="py-4 bg-[#0000000a]"></p>
          )
        ) : (
          <Input
            className="focus-within:!border-none !rounded-none focus-within:!outline-none focus:!border-none focus:!outline-none !outline-none !border-none !m-0 bg-[#0000000a]"
            value={text || ''}
            disabled={record.without_tool_disabled}
          />
        ),
    },
    {
      title: (
        <span className="font-semibold text-sm font-['SF-Pro-Text-Regular, sans-serif'] text-white">
          Total
        </span>
      ),
      dataIndex: 'total',
      key: 'total',
      width: '10%',
      render: (text, record) =>
        record.key === '4' ? (
          <p className="py-4"></p>
        ) : user_details?.user?.Role?.role === 'REQUESTER' ? (
          record.total ? (
            <Form.Item name={record.total} className="!m-0 !p-0" noStyle>
              <Input
                className="focus-within:!border-none !rounded-none focus-within:!outline-none focus:!border-none focus:!outline-none !outline-none !border-none !m-0"
                disabled={record.total_disabled}
              />
            </Form.Item>
          ) : (
            <p className="py-4 bg-[#0000000a]"></p>
          )
        ) : (
          <Input
            className="focus-within:!border-none !rounded-none focus-within:!outline-none focus:!border-none focus:!outline-none !outline-none !border-none !m-0"
            value={text || ''}
            disabled={record.total_disabled}
          />
        ),
    },
  ];
  console.log('DATA', datasource);

  const steps = [
    {
      title: <div className="step-title">Quarterly Input</div>,
      content: (
        <Form form={form} layout="vertical" onValuesChange={handleChange}>
          <Space direction="vertical" size={24} style={{ width: '100%' }}>
            <Card bodyStyle={{ paddingBottom: '8px' }}>
              <Row gutter={24}>
                {user_details?.user?.Role?.role?.toUpperCase() ===
                  'MANAGER' && (
                  <Col span={8} xs={24} sm={8}>
                    <Form.Item label="Project Code" name="project_code">
                      <Select
                        loading={getViewProjectLoading}
                        placeholder="Select or enter project code"
                        onChange={handleProjectCodeChange}
                        showSearch
                        mode="combobox"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {projectListManagerData?.list?.map(
                          (projectCode, index) => (
                            <Select.Option key={index} value={projectCode}>
                              {projectCode}
                            </Select.Option>
                          ),
                        )}
                      </Select>
                    </Form.Item>
                  </Col>
                )}

                {user_details?.user?.Role?.role?.toUpperCase() ===
                  'REQUESTER' && (
                  <Col span={8} xs={24} sm={8}>
                    <Form.Item label="Project Code" name="project_code">
                      <Select
                        loading={getViewProjectLoading}
                        placeholder="Select or enter project code"
                        onChange={handleProjectCodeChange}
                        showSearch
                        mode="combobox"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {projectListData?.list?.map((projectCode, index) => (
                          <Select.Option key={index} value={projectCode}>
                            {projectCode}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                )}

                {user_details?.user?.Role?.role?.toUpperCase() === 'MANAGER' &&
                  (quarterlyViewData ? (
                    <>
                      <Col span={8} xs={24} sm={8}>
                        <Form.Item label="Project Name">
                          <Input
                            placeholder="Project name"
                            value={
                              getViewProjectData?.project_name ||
                              quarterlyViewData?.data?.project_name
                            }
                            disabled
                          />
                        </Form.Item>
                      </Col>

                      {/* <Col span={8} xs={24} sm={8}>
                        <Form.Item label="Estimate The Total Tonnage For The Quarter">
                          <Input
                            placeholder="Enter total tonnage for the quarter"
                            value={
                              quarterlyViewData?.data?.total_tonnage_for_quarter
                            }
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={8} xs={24} sm={8}>
                        <Form.Item label="Budgeted Wastage (%)">
                          <Input
                            placeholder="Enter budgeted wastage"
                            value={quarterlyViewData?.data?.budgeted_wastage}
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </Col> */}
                    </>
                  ) : null)}

                {user_details?.user?.Role?.role?.toUpperCase() ===
                  'REQUESTER' && (
                  <>
                    <Col span={8} xs={24} sm={8}>
                      <Form.Item label="Project Name" name="project_name">
                        <Input placeholder="Project name" disabled />
                      </Form.Item>
                    </Col>

                    {/* <Col span={8} xs={24} sm={8}>
                      <Form.Item
                        label="Estimate The Total Tonnage For The Quarter"
                        name="total_tonnage_for_quarter"
                      >
                        <Input
                          placeholder="Enter total tonnage for the quarter"
                          disabled={fieldsDisabled}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8} xs={24} sm={8}>
                      <Form.Item
                        label="Budgeted Wastage (%)"
                        name="budgeted_wastage"
                      >
                        <Input
                          placeholder="Enter budgeted wastage"
                          disabled={fieldsDisabled}
                        />
                      </Form.Item>
                    </Col> */}
                  </>
                )}

                <Col span={8} xs={24} sm={8}>
                  <Form.Item
                    label="Select The Financial Year"
                    name="financial_year"
                    rules={[{ message: 'Please select the Financial year' }]}
                  >
                    <Select
                      placeholder="Select the financial year"
                      className="custom-select"
                      onChange={handleFinancialYearChange}
                    >
                      {financialYear?.year_list?.map((year, index) => (
                        <Select.Option key={index} value={year}>
                          {year}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={8} xs={24} sm={8}>
                  <Form.Item
                    label="Select The Quarter"
                    name="quarter"
                    rules={[{ message: 'Please select the quarter' }]}
                  >
                    <Select
                      placeholder="Select the quarter"
                      className="custom-select"
                      onChange={handleQuarterChange}
                    >
                      {quarter?.quarters?.map((qtr, index) => (
                        <Select.Option key={index} value={qtr}>
                          {qtr}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Card>
              <Table
                columns={columns}
                dataSource={datasource}
                pagination={false}
                className="custom-table"
                bordered
              />
            </Card>
            {user_details?.user?.Role?.role?.toUpperCase() === 'MANAGER' ? (
              quarterlyViewData ? (
                <>
                  {/* <Card
                    bodyStyle={{ paddingBottom: '8px' }}
                    title="With BBS"
                    headStyle={{
                      borderBottom: 'none',
                      color: '#1C4E9D',
                      fontFamily: "'SF Pro Text', sans-serif",
                      fontSize: '16px',
                      fontWeight: 500,
                      marginBottom: '-27px',
                    }}
                  >
                    <Row gutter={24}>
                      <Col span={8} xs={24} sm={24} md={24} lg={8}>
                        <Form.Item label="Estimate The Tonnage With BBS">
                          <Input
                            placeholder="Enter estimate the tonnage with bbs"
                            value={
                              quarterlyViewData?.data?.estimate_tonnage_with_bbs
                            }
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={8} xs={24} sm={24} md={24} lg={8}>
                        <Form.Item label="Estimate Waste Percentage - System (%)">
                          <Input
                            placeholder="Enter estimate waste percentage - system(%)"
                            value={
                              quarterlyViewData?.data?.estimate_waste_per_system
                            }
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={8} xs={24} sm={24} md={24} lg={8}>
                        <Form.Item
                          label="With Estimate Waste Percentage - Actual (%)"
                          //name="estimate_waste_per_actual"
                          //rules={[{ message: "Please enter the project code" }]}
                        >
                          <Input
                            placeholder="Enter with estimate waste percentage - acutal (%)"
                            value={
                              quarterlyViewData?.data?.estimate_waste_per_actual
                            }
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card> */}

                  {/* <Card
                    bodyStyle={{ paddingBottom: '8px' }}
                    title="Without BBS"
                    headStyle={{
                      borderBottom: 'none',
                      color: '#1C4E9D',
                      fontFamily: "'SF Pro Text', sans-serif",
                      fontSize: '16px',
                      fontWeight: 500,
                      marginBottom: '-27px',
                    }}
                  >
                    <Row gutter={24}>
                      <Col span={8} xs={24} sm={8}>
                        <Form.Item label="Estimate The Tonnage Without BBS">
                          <Input
                            placeholder="Enter estimate the tonnage without bbs"
                            value={
                              quarterlyViewData?.data
                                ?.estimate_tonnage_without_bbs
                            }
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={8} xs={24} sm={24} md={24} lg={8}>
                        <Form.Item label="With Estimate Waste Percentage - Actual (%)">
                          <Input
                            placeholder="Enter estimate waste percentage - acutal(%0"
                            value={
                              quarterlyViewData?.data
                                ?.estimate_waste_per_actual_wo
                            }
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card> */}

                  {/* <Card
                    headStyle={{
                      borderBottom: 'none',
                      fontSize: '14px',
                      fontWeight: '500',
                      fontFamily: "'SF Pro Text', sans-serif",
                      color: '#1C4E9D',
                    }}
                    bodyStyle={{
                      paddingTop: '4px',
                      paddingBottom: '8px',
                      marginTop: '10px',
                    }}
                  >
                    <Row gutter={24}>
                      <Col span={24} sm={8} xs={24}>
                        <Form.Item
                          label={
                            <div className="flex items-center">
                              <label>Wastage Monitoring (%)</label>
                              <div>
                                <Tooltip
                                  title="Difference of budgeted wastage and actual wastage during execution (with tool)"
                                  overlayInnerStyle={{ fontSize: '10px' }}
                                >
                                  <img
                                    src={dashboardCircle} // Replace with the correct import or path to your icon
                                    alt="Dashboard Circle Icon"
                                    style={{
                                      width: '12px', // Set the size of the icon
                                      height: '12px',
                                      cursor: 'pointer', // Makes it clear it's interactive
                                      marginLeft: '5px', // Space between label and icon
                                    }}
                                  />
                                </Tooltip>
                              </div>
                            </div>
                          }
                        >
                          {/* Difference of budgeted wastage and actual wastage during execution (with tool) */}
                  {/* <Input
                            placeholder="Enter wastage monitoring"
                            value={quarterlyViewData?.data?.wastage_monitoring}
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card> */}

                  {/* <Card
                    bodyStyle={{ paddingBottom: '8px' }}
                    title="Saving Calculations"
                    headStyle={{
                      borderBottom: 'none',
                      color: '#1C4E9D', // Text color
                      fontFamily: "'SF Pro Text', sans-serif", // Font family
                      fontSize: '16px', // Font size
                      fontWeight: 500, // Font weight
                      marginBottom: '-27px',
                    }}
                  >
                    <Row gutter={24}>
                      <Col span={8} xs={24} sm={24} md={24} lg={8}>
                        <Form.Item
                          label="Savings(%)"

                          //rules={[{ message: "Please enter the project code" }]}
                        >
                          <Input
                            placeholder="Enter savings(%)"
                            value={quarterlyViewData?.data?.savings_per}
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8} xs={24} sm={24} md={24} lg={8}>
                        <Form.Item label="Savings(in Tons)">
                          <Input
                            placeholder="Enter savings in tons"
                            value={quarterlyViewData?.data?.savings_in_ton}
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={8} xs={24} sm={24} md={24} lg={8}>
                        <Form.Item label="Savings (in Lakhs ₹)">
                          <Input
                            placeholder="Enter savings in lakhs"
                            value={quarterlyViewData?.data?.savings_in_lakh}
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card> */}

                  {/* <Card
                    bodyStyle={{ paddingBottom: '8px' }}
                    title="Overall Waste Percentage"
                    headStyle={{
                      borderBottom: 'none',
                      color: '#1C4E9D',
                      fontFamily: "'SF Pro Text', sans-serif",
                      fontSize: '16px',
                      fontWeight: 500,
                      marginBottom: '-27px',
                    }}
                  >
                    <Row gutter={24}>
                      <Col span={24} sm={12} xs={24}>
                        <Form.Item label="Calculate Waste Percentage">
                          <Row gutter={12} align="middle" wrap={false}>
                            <Col span={12} xs={10} sm={15} md={10} lg={7}>
                              <button
                                //disabled={isDisabled}
                                className={`w-[100%] h-[37px] pt-0 pb-0 font-['SF-Pro-Text-Regular, sans-serif'] lg:px-2 lg:text-[14px] md:px-2 sm:px-2 ${
                                  isDisabled
                                    ? 'bg-gray-400 cursor-not-allowed'
                                    : 'bg-[#1C4E9D] text-[#FFFFFF]'
                                }`}
                              >
                                Calculate
                              </button>
                            </Col>
                            <Col span={12} xs={14} sm={20} md={18} lg={17}>
                              <Input
                                placeholder="Enter calculate waste percentage"
                                value={
                                  quarterlyViewData?.data
                                    ?.overall_waste_percentage
                                }
                                disabled={isDisabled}
                              />
                            </Col>
                          </Row>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card> */}
                </>
              ) : (
                <p>Loading...</p>
              )
            ) : (
              <>
                {/* <Card
                  bodyStyle={{ paddingBottom: '8px' }}
                  title="With BBS"
                  headStyle={{
                    borderBottom: 'none',
                    color: '#1C4E9D', // Text color
                    fontFamily: "'SF Pro Text', sans-serif", // Font family
                    fontSize: '16px', // Font size
                    fontWeight: 500, // Font weight
                    marginBottom: '-27px',
                  }}
                >
                  <Row gutter={24}>
                    <Col span={8} xs={24} sm={24} md={24} lg={8}>
                      <Form.Item
                        label="Estimate The Tonnage With BBS"
                        name="estimate_tonnage_with_bbs"
                        //rules={[{ message: "Please enter the project code" }]}
                      >
                        <Input placeholder="Enter estimate the tonnage with bbs" />
                      </Form.Item>
                    </Col>
                    <Col span={8} xs={24} sm={24} md={24} lg={8}>
                      <Form.Item
                        label="Estimate Waste Percentage - System (%)"
                        name="estimate_waste_per_system"
                      >
                        <Space.Compact style={{ width: '100%' }}>
                          <Input
                            placeholder="Enter estimate the waste percentage - system (%)"
                            value={estimatedValueApi}
                            disabled={estimatedWasteVal}
                          />
                          <Button
                            onClick={handleFetchEstimate}
                            className="bg-[#F3F8FF] border-[1px] border-[#F3F8FF] text-[#1C4E9D] font-['SF-Pro-Text-Regular, sans-serif'] text-[14px]"
                            type="button"
                          >
                            Estimate
                          </Button>
                        </Space.Compact>
                      </Form.Item>
                    </Col>

                    <Col span={8} xs={24} sm={24} md={24} lg={8}>
                      <Form.Item
                        label="With Estimate Waste Percentage - Actual (%)"
                        name="estimate_waste_per_actual"
                        //rules={[{ message: "Please enter the project code" }]}
                      >
                        <Input
                          placeholder="Enter with estimate waste percentage - actual(%0"
                          onChange={handleEstimateActualChange}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card> */}

                {/* <Card
                  bodyStyle={{ paddingBottom: '8px' }}
                  title="Without BBS"
                  headStyle={{
                    borderBottom: 'none',
                    color: '#1C4E9D', // Text color
                    fontFamily: "'SF Pro Text', sans-serif", // Font family
                    fontSize: '16px', // Font size
                    fontWeight: 500, // Font weight
                    marginBottom: '-27px',
                  }}
                >
                  <Row gutter={24}>
                    <Col span={8} xs={24} sm={8}>
                      <Form.Item
                        label="Estimate The Tonnage Without BBS"
                        name="estimate_tonnage_without_bbs"
                        //rules={[{ message: "Please enter the project code" }]}
                      >
                        <Input placeholder="Enter estimate the tonnage without bbs" />
                      </Form.Item>
                    </Col>
                    <Col span={8} xs={24} sm={24} md={24} lg={8}>
                      <Form.Item
                        label="With Estimate Waste Percentage - Actual (%)"
                        name="estimate_waste_per_actual_wo"
                        //rules={[{ message: "Please enter the project code" }]}
                      >
                        <Input placeholder="Enter with estimate waste percentage - actual(%)" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card> */}

                {/* <Card
                  headStyle={{
                    borderBottom: 'none',
                    fontSize: '14px',
                    fontWeight: '500',
                    fontFamily: "'SF Pro Text', sans-serif",
                    color: '#1C4E9D',
                  }}
                  bodyStyle={{
                    paddingTop: '4px',
                    paddingBottom: '8px',
                    marginTop: '10px',
                  }}
                >
                  <Row gutter={24}>
                    <Col span={24} sm={8} xs={24}>
                      <Form.Item
                        label={
                          <>
                            Wastage Monitoring (%)
                            <Tooltip
                              title="Difference of budgeted wastage and actual wastage during execution (with tool)"
                              overlayInnerStyle={{ fontSize: '10px' }}
                            >
                              <img
                                src={dashboardCircle} // Replace with the correct import or path to your icon
                                alt="Dashboard Circle Icon"
                                style={{
                                  width: '12px', // Set the size of the icon
                                  height: '12px',
                                  cursor: 'pointer', // Makes it clear it's interactive
                                  marginLeft: '5px', // Space between label and icon
                                }}
                              />
                            </Tooltip>
                          </>
                        }
                        name="wastage_monitoring"
                      >
                        <Input
                          placeholder="Enter wastage monitoring"
                          disabled={wastedisabled}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card> */}

                {/* <Card
                  bodyStyle={{ paddingBottom: '8px' }}
                  title="Saving Calculations"
                  headStyle={{
                    borderBottom: 'none',
                    color: '#1C4E9D', // Text color
                    fontFamily: "'SF Pro Text', sans-serif", // Font family
                    fontSize: '16px', // Font size
                    fontWeight: 500, // Font weight
                    marginBottom: '-27px',
                  }}
                >
                  <Row gutter={24}>
                    <Col span={8} xs={24} sm={24} md={24} lg={8}>
                      <Form.Item label="Savings(%)" name="savings_per">
                        <Input
                          placeholder="Enter savings(%)"
                          disabled={savings}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8} xs={24} sm={24} md={24} lg={8}>
                      <Form.Item label="Savings(in Tons)" name="savings_in_ton">
                        <Input
                          placeholder="Enter savings in tons"
                          disabled={savings}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8} xs={24} sm={24} md={24} lg={8}>
                      <Form.Item
                        label={
                          <>
                            Savings (in Lakhs ₹)
                            <Tooltip
                              title="Cost @ Rs 55,0000/T"
                              overlayInnerStyle={{ fontSize: '10px' }}
                            >
                              <img
                                src={dashboardCircle} // Replace with the correct import or path to your icon
                                alt="Dashboard Circle Icon"
                                style={{
                                  width: '12px', // Set the size of the icon
                                  height: '12px',
                                  cursor: 'pointer', // Makes it clear it's interactive
                                  marginLeft: '5px', // Space between label and icon
                                }}
                              />
                            </Tooltip>
                          </>
                        }
                        name="savings_in_lakh"
                      >
                        <Input
                          placeholder="Enter savings in lakhs"
                          disabled={calculation}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card> */}

                {/* <Card
                  bodyStyle={{ paddingBottom: '8px' }}
                  title="Overall Waste Percentage"
                  headStyle={{
                    borderBottom: 'none',
                    color: '#1C4E9D', // Text color
                    fontFamily: "'SF Pro Text', sans-serif",
                    fontSize: '16px', // Font size
                    fontWeight: 500,
                    marginBottom: '-27px',
                  }}
                > */}
                {/* <Row gutter={24}>
                    <Col span={24} sm={12} xs={24}>
                      <Form.Item
                        label="Calculate Waste Percentage"
                        name="total_qty"
                        rules={[{ message: 'Please enter SBU' }]}
                      >
                        <Row gutter={12} align="middle" wrap={false}>
                          <Col span={12} xs={10} sm={15} md={10} lg={7}>
                            <button
                              onClick={handleSubmit}
                              className="w-[100%] h-[37px] pt-0 pb-0 bg-[#1C4E9D] text-[#FFFFFF] font-['SF-Pro-Text-Regular, sans-serif'] lg:px-2 lg:text-[14px]
                                        md:px-2 sm:px-2"
                            >
                              Calculate
                            </button>
                          </Col>

                          {/* Input field with responsive spans */}
                {/* <Col span={12} xs={14} sm={20} md={18} lg={17}>
                            <Input
                              placeholder="Enter calculate waste percentage"
                              value={overallWastePer}
                            />
                          </Col> */}
                {/* </Row>
                      </Form.Item>
                    </Col>
                  </Row> */}
                {/* </Card> */}
              </>
            )}
          </Space>
        </Form>
      ),
    },
  ];

  return (
    <div className="main-div">
      <div className="flex items-center gap-2 mt-4 ml-8 barchart-text">
        <img src={quaterly_input} alt="bar chart" />
        <p className="p-1 text-sm font-semibold text-gray-700 bg-white rounded-lg">
          Quarterly Input
        </p>
      </div>
      <div className="steps_parent_bbs ">
        <Steps
          className="steps_track_bbs"
          style={{ width: 'auto' }}
          current={currentStep}
          labelPlacement="vertical"
        >
          {steps.map((item, index) => (
            <Step
              key={index}
              icon={
                <img
                  src={step_base_icon}
                  alt="Step Icon"
                  className="step-icon"
                />
              }
              title={
                <div className="flex flex-col step-title-container">
                  <div className="text-sm font-semibold text-blue-800 step-title">
                    {item.title}
                  </div>
                </div>
              }
            />
          ))}
        </Steps>
      </div>

      <div className="flex items-center justify-center step-card ">
        <div className="steps_content_parent ">
          <Card>
            <div className="steps-content">
              {steps[currentStep] ? (
                steps[currentStep].content
              ) : (
                <div>No content available</div>
              )}
            </div>
            <div className="mt-4 text-center steps-action">
              {currentStep === 0 && (
                <>
                  <Button
                    style={{ margin: '0 8px' }}
                    onClick={() => navigate('/dashboard')}
                    className="px-4 py-2 text-blue-800 bg-white rounded-lg prev-button"
                  >
                    Back to Dashboard
                  </Button>
                  {user_details?.user?.Role?.role?.toUpperCase() ===
                    'REQUESTER' && (
                    <Button
                      type="primary"
                      loading={loading}
                      onClick={onSubmit}
                      className="px-4 py-2 text-white bg-blue-800 rounded-lg next-button"
                    >
                      Submit
                    </Button>
                  )}
                </>
              )}
            </div>
          </Card>
        </div>
      </div>
      <Modal
        title="Alert"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleOk}
        okText="OK"
        cancelText="Cancel"
        className="custom-modal"
        okButtonProps={{ className: 'next-button' }} // Custom class for OK button
        cancelButtonProps={{ className: 'prev-button' }} // Custom class for Cancel button
      >
        <p>Project does not have optimized BBS for the selected quarter.</p>
      </Modal>
    </div>
  );
};

export default QuarterlyInputPage;

{
  /* <button
    className="
        w-full sm:w-[96px] md:w-[80px] 
        h-[37px] sm:h-[40px] md:h-[35px] 
        lg:h-[45px]                    
        bg-[#1C4E9D] text-[#FFFFFF]
        text-[12px] sm:text-[14px] md:text-[12px] lg:text-[16px] 
        font-['SF-Pro-Text-Regular, sans-serif']
        rounded-md px-2 py-2
    "
>
    Calculate
</button> */
}
